export * from "./photo.component";
